import useRestService from '../shared/rest-service';

const useLogin = () => {
  const { postAuth } = useRestService();

  /**
   * changePassword
   * @method changePassword - API call to change the password
   * @param id ID of the client
   * @param oldPassword Client's old password
   * @param newPassword Client's new password
   */
  const changePassword = (userId: string, oldPassword: string, newPassword: string) => {
    return postAuth('api/accounts/change-password', { userId, oldPassword, newPassword });
  };

  return {
    changePassword
  };
};

export default useLogin;
